import { BehaviorTreeBuilder } from '../../behaviourTree/BehaviorTreeBuilder';
import { TaskStatus } from '../../behaviourTree/TaskStatus';
import { HasComponentCondition, AddComponentAction, RemoveComponentAction, HasTagCondition, ModifyComponentAction, WaitTimeAction, IsActiveCondition, DestroyEntityAction } from '../behaviors/ECSBehaviors';
/**
 * ECS特化的行为树构建器
 * 提供方便的ECS相关节点创建方法
 */
export class ECSBehaviorTreeBuilder extends BehaviorTreeBuilder {
    /**
     * 添加组件存在检查条件
     */
    hasComponent(componentType) {
        const condition = new HasComponentCondition(componentType);
        return this.conditional((entity) => condition.update(entity));
    }
    /**
     * 添加组件
     */
    addComponent(componentType, factory) {
        const addAction = new AddComponentAction(componentType, factory);
        return this.action((entity) => addAction.update(entity));
    }
    /**
     * 移除组件
     */
    removeComponent(componentType) {
        const removeAction = new RemoveComponentAction(componentType);
        return this.action((entity) => removeAction.update(entity));
    }
    /**
     * 检查实体标签
     */
    hasTag(tag) {
        const condition = new HasTagCondition(tag);
        return this.conditional((entity) => condition.update(entity));
    }
    /**
     * 修改组件属性
     */
    modifyComponent(componentType, modifier) {
        const modifyAction = new ModifyComponentAction(componentType, modifier);
        return this.action((entity) => modifyAction.update(entity));
    }
    /**
     * 等待指定时间
     */
    waitTime(seconds) {
        const waitAction = new WaitTimeAction(seconds);
        return this.action((entity) => {
            // 管理WaitAction的生命周期
            if (waitAction.status === TaskStatus.Invalid) {
                waitAction.onStart();
            }
            const result = waitAction.update(entity);
            if (result !== TaskStatus.Running) {
                waitAction.onEnd();
            }
            return result;
        });
    }
    /**
     * 检查实体是否活跃
     */
    isActive(checkHierarchy = true) {
        const condition = new IsActiveCondition(checkHierarchy);
        return this.conditional((entity) => condition.update(entity));
    }
    /**
     * 销毁实体
     */
    destroyEntity() {
        const destroyAction = new DestroyEntityAction();
        return this.action((entity) => destroyAction.update(entity));
    }
    /**
     * 执行自定义ECS逻辑
     */
    executeECS(logic) {
        return this.action((entity) => {
            try {
                const result = logic(entity);
                if (typeof result === 'boolean') {
                    return result ? TaskStatus.Success : TaskStatus.Failure;
                }
                return TaskStatus.Success;
            }
            catch (error) {
                console.error('ECS逻辑执行错误:', error);
                return TaskStatus.Failure;
            }
        });
    }
    /**
     * 条件执行 - 如果条件为真则执行成功，否则失败
     */
    conditionECS(predicate) {
        return this.conditional((entity) => {
            try {
                return predicate(entity) ? TaskStatus.Success : TaskStatus.Failure;
            }
            catch (error) {
                console.error('条件检查错误:', error);
                return TaskStatus.Failure;
            }
        });
    }
    /**
     * 日志输出
     */
    log(message, level = 'info') {
        return this.action((entity) => {
            try {
                const msg = typeof message === 'function' ? message(entity) : message;
                const entityInfo = `[实体${entity.id}:${entity.name}]`;
                switch (level) {
                    case 'info':
                        console.log(`${entityInfo} ${msg}`);
                        break;
                    case 'warn':
                        console.warn(`${entityInfo} ${msg}`);
                        break;
                    case 'error':
                        console.error(`${entityInfo} ${msg}`);
                        break;
                }
                return TaskStatus.Success;
            }
            catch (error) {
                console.error('日志输出错误:', error);
                return TaskStatus.Failure;
            }
        });
    }
    /**
     * 构建专用于ECS的行为树
     */
    buildECSTree(updateInterval = 0.1) {
        const rootBehavior = this.build(updateInterval);
        return rootBehavior;
    }
}
//# sourceMappingURL=ECSBehaviorTreeBuilder.js.map